import styled from 'styled-components';

interface ICheckboxInput {
  selected?: boolean;
}

export const Container = styled.div`
  display: flex;
  justify-content: center;
`;

export const CheckboxInput = styled.label<ICheckboxInput>`
  display: flex;
  align-items: center;

  span {
    color: #202020;
    font-weight: 500;
  }

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 24px;
    min-height: 24px;
    border-radius: 4px;
    margin-right: 8px;
    transition-duration: 0.3s;
    background: ${(props) => (props.selected ? '#FF6900' : '#fff')};
    border: 1px solid #d3d3d3;
  }

  .inputData {
    display: none;
  }

  + label {
    margin-left: 20px;
  }
`;

export const Error = styled.span`
  font-size: 11px !important;
`;
